
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';

    export default {
        name: 'QuestionBoolean',

        mixins: [
            QuestionMixin,
        ],

        data() {
            return {
                answer: false,
                questionId: `question_boolean_${this.question.id}`,
            };
        },

        created() {
            this.getStringAnswer();
        },

        methods: {},
    };
